module.exports = __webpack_public_path__ + "static/media/ufo-beam.925dc375.svg";